import { getFragment } from "core/services/site/fragment";

const getTaskId = async (
    sessionToken: string,
    fragmentID: number,
): Promise<number | undefined> => {
    const fragmentInfo = await getFragment(sessionToken, fragmentID);
    if (fragmentInfo.error) {
        console.error(fragmentInfo.error);
        return undefined;
    }
    return fragmentInfo.value?.processingTaskId;
};

export default getTaskId;
